import Amplitude from '../../../../tools/amplitude/amplitude';
import { EVENT_NAME } from './Analytics.const';

const logCargo = params => Amplitude.logEvent(EVENT_NAME, params);

export const AnalyticActions = {
  logCargo,
};
